import type { SignupStep } from '../utils/steps';

/**
 * The onboarding steps collect product answers after the account decision is
 * already made, so the notice would be noise there. Every other step shows it.
 */
const STEPS_WITHOUT_TERMS_NOTICE = new Set<SignupStep>([
  'onboarding_usage',
  'channels',
  'data_center',
  'startup_complete',
]);

export function shouldShowTermsNotice(step: SignupStep): boolean {
  return !STEPS_WITHOUT_TERMS_NOTICE.has(step);
}
